import React from 'react';
import ButtonLink, {
  Props as ButtonLinkProps,
} from '@teetsh/app/src/components/Buttons/Link';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { useParams } from 'react-router-dom';
import SchoolyearButtonLink from '@teetsh/app/src/components/Buttons/SchoolyearButtonLink';
import Button from 'components/Buttons/Button';

interface Props {
  to: string;
  onClick?: (e?: React.MouseEvent) => void;
}

export function CahierJournalButtonLink(props: Props & ButtonLinkProps) {
  const { to, ...rest } = props;
  const user = useUser();
  const { userId, token } = useParams<{
    token: string;
    userId: string;
  }>();

  if (user.guestMode?.enabled && userId && token) {
    return <ButtonLink to={`/shares/${userId}/t/${token}/${to}`} {...rest} />;
  }
  if (props.onClick) {
    return <Button {...rest} />;
  }

  return <SchoolyearButtonLink to={to} {...rest} />;
}
